import './track-controls.sass';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n';

import redirect from 'actions/redirect';
import request from 'actions/request';

let buttons = [
  { key: 'events', classModifyer: 'glyphicon-flag', handler: 'handleClickShowTrackEvents' },
  { key: 'params', classModifyer: 'glyphicon-check', handler: 'handleClickShowTrackParams' },
  { key: 'templates', classModifyer: 'glyphicon-star', handler: 'handleClickShowTrackTemplates' },
  { key: 'view', classModifyer: 'glyphicon-picture', handler: 'handleClickShowChart' },
];

class TrackControls extends Component {
  handleClickTrash() {
    if (confirm(I18n.t('tracksTree.trackControls.confirm'))) {
      this.props.request(
        ['tracks', 'delete'],
        'delete',
        'TRACK',
        { id: this.props.track.id }
      );
    }
  }

  handleClickShowTrackEvents() {
    this.props.redirect('/track-events/' + this.props.track.id);
  }

  handleClickShowTrackTemplates() {
    this.props.redirect('/track-templates/' + this.props.track.id);
  }

  handleClickShowTrackParams() {
    this.props.redirect('/track-params/' + this.props.track.id);
  }

  handleClickShowChart() {
    this.props.redirect('/chart'
      + '/track-id/' + this.props.track.id
      +'/template-name/default'
      + '/from-frame/0'
      + '/to-frame/' + this.props.track.framesCount);
  }

  buildButtons() {
    let control = (
      <span
        className={ 'tracks-tree-track-controls__glyphicon glyphicon glyphicon-flag' }
        onClick={ this.handleClickShowTrackEvents.bind(this) }
      ></span>
    );

    if (this.props.pending !== false) {
      return control;
    }

    buttons.forEach(((item, index) => {
      if ((this.props.settings.trackShowAction === item.key)
        && (typeof this[item.handler] === 'function')
      ) {
        control = (
          <span
            className={ 'tracks-tree-track-controls__glyphicon glyphicon ' + item.classModifyer }
            onClick={ this[item.handler].bind(this) }
          ></span>
        );
      }
    }).bind(this));

    return control;
  }

  render() {
    return (
      <div className='tracks-tree-track-controls'>
        { this.buildButtons() }
        <span
          className={
            'tracks-tree-track-controls__glyphicon '
            + 'tracks-tree-track-controls__glyphicon-danger '
            + 'glyphicon '
            + 'glyphicon-trash'
          }
          onClick={ this.handleClickTrash.bind(this) }
        ></span>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pending: state.settings.pending,
    settings: state.settings.items
  };
}

function mapDispatchToProps(dispatch) {
  return {
    redirect: bindActionCreators(redirect, dispatch),
    request: bindActionCreators(request, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TrackControls);
